import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
const AdmissionProcess = () => {
    useEffect(() => {
        document.title = 'Admission Process -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Admission Process </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>Admission</li>
                            <li>|</li>
                            <li> Admission Process </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h1 className="head1" >The new academic session begins in early April every year. Classes are designated as follows:</h1>
                        <div class="table-responsive">
                        <table class="table maintable"> 
                           <tbody> 
                               <tr> 
                                <td className="classbg"><b>Class</b></td> 
                                <td>Playgroup</td> 
                                <td>LKG</td> 
                                <td>UKG</td> 
                                <td>1</td> 
                                <td>2</td> 
                                <td>3</td> 
                                <td>4</td> 
                                <td>5</td> 
                                <td>6</td> 
                                <td>7</td> 
                                <td>8</td> 
                                <td>9</td> 
                                <td>10</td>
                               </tr> 
                               <tr> 
                                <td className="agebg"><b>Age</b></td> 
                                <td>2.5-3.5 years</td> 
                                <td>3.5-4 years</td> 
                                <td>4-5 years</td> 
                                <td>5-6 years</td> 
                                <td>6-7 years</td> 
                                <td>7-8 years</td> 
                                <td>8-9 years</td> 
                                <td>9-10 years</td> 
                                <td>10-11 years</td> 
                                <td>11-12 years</td> 
                                <td>12-13 years</td> 
                                <td>13-14 years</td> 
                                <td>14-15 years</td>
                              </tr> 
                            </tbody>
                           </table> 
                       </div>
                        <p> Admission offered in various classes is subject to the availability of seats.The lower age limit for admission in the School is 3.5 years on 1st April of the year of joining the School in Class LKG. Similarly, correlation of age and class to which admission is sought is an essential requirement.</p>
                        <h1 className="head1">Procedure for Registration</h1>
                        <p>An application form for registration is the first stage of the admission process. <strong>The Registration form is available online only. Once the form is successfully submitted SMS will be sent. Registration Fee will be charged at the time of interaction.</strong> The fee is neither refundable nor adjustable and it is valid only for the specified academic year. Registration of a child  is not a guarantee of his/her admission.</p>
                        <h1 className="head1">Requirements at the time of registration:</h1>
                        <ul className="list schoolfee">
                        <li> One recent passport size photograph of the child has to be attached.</li>
                        <li> The completed Registration Form  must be submitted along with an attested photocopy of the child's Birth Certificate and Transfer Certificate(if applicable).</li>
                        <li> The Birth Certificate should be issued by the Registrar of Births and Deaths of the area in which the child was born. Affidavits, certificates from the hospital, or certificates from any other person are not accepted. The Birth Certificate should not be dated more than one year after the date of birth.</li>
                        </ul>
                        <h1 className="head1">Aptitude/Proficiency Assessment </h1>
                        <ul className="list schoolfee">
                        <li>Every student registered for admission into classes UKG to IX is expected to appear for an Aptitude/Proficiency Assessment at the school. The Assessment is held on the date mentioned on the Registration Slip.</li>
                        <li>Offers of admission are given on the basis of the results of these Assessments and depend on the number of vacancies in each class. Some preference is given to children of transferable Government officials and serving Armed Forces personnel. Preference is also given to those whose real siblings have studied or are at present studying in the School.</li>
                        <li>Any requests for other preferential treatment are not entertained. Only in very rare and exceptional cases, the Principal  reserves the right to exercise her discretion in the matter of admissions.</li>
                        <li>The student is also required to pass a medical fitness test.</li>
                        <li><strong>The School fully reserves the right of Admission and its decision in the matter is final and binding and cannot be questioned.</strong></li>
                        <li><strong>The School reserves the right to change its Admissions procedure from time to time without notice.</strong></li>
                        </ul>
                        <h1 className="head1">Documents Required at the Time of Admission </h1>
                        <p><strong>The following documents are required as a part of the Admissions procedure for every student applying for admission:</strong></p>
                        <p><strong>1.</strong> Photographs</p>
                        <ul className="list schoolfee">
                        <li>3 recent passport size photographs of the student</li>
                        <li>1 recent passport size photograph of the parents</li>
                        </ul>
                        <p><strong>2.</strong> Original Birth Certificate</p>
                        <ul className="list schoolfee">
                        <li>The original birth certificate must be brought to the School at the time of admission. This is returned after verification. Misrepresentation or falsification of date of birth will result in cancellation of admission forthwith.</li>
                        </ul>
                        <p><strong>3.</strong> Transfer Certificate, Character Certificate</p>
                        <ul className="list schoolfee">
                        <li>A valid Transfer Certificate from the School last attended must be submitted on the day that the child joins School. In addition, the student is required to present the last Report Card indicating promotion to the next class . Until the Transfer Certificate and other documents are received by the School, the child's admission is considered as provisional.</li>
                        </ul>
                        <p><strong>4.</strong> Medical Certificate</p>
                        <ul className="list schoolfee">
                        <li>All new entrants are required to produce a medical certificate certifying that they are free from any contagious or infectious disease.</li>
                        </ul>
                     </div>
                </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default AdmissionProcess